import gql from 'graphql-tag';

const TOGGLE_DEX_SELECTION = gql`
	mutation toggleDexSelection ($id: ID!) {
		toggleDexSelection(id: $id) {
			id
			enabled
		}
	}
`;

export default TOGGLE_DEX_SELECTION;
